export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-05.30f6be4c.jpg";